import 'slick-carousel'
global.$ = global.jQuery = $

document.addEventListener('turbo:load', function () {
  // testimonials
  $('.slick').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  })

  // carousel for social images in dynamic pages
  $('.slick-social').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    centerMode: true,
    centerPadding: '60px',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  // carousel for events page
  $('.slick-events').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
  })

  // core carousel component
  $('.core-carousel-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
  })

  $('.testimonial-slice').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
  })
})
